import React from 'react';
import styled from 'styled-components';
import {proto,url} from '../../Helpers/api';
import Tabela, {TabelaLinha as TL} from '../../Common/Tabela';
import Celula from '../../Common/Celula';
import { MesExtenso } from '../../Helpers/date';
import MoreInfo from './index';

const TabelaLinha = styled(TL)`
  grid-template-columns: 40px 280px 80px;
`
export default function MIRescisoes (props) {
  const { dados={} } = props;
  const { empresa, mes, ano } = dados;
  return (
    <MoreInfo
      titulo={empresa}        
      subtitulo={`Rescisões (${MesExtenso(dados.mes-1)}/${dados.ano})`}
      modalData={dados}
      f={{
        url: `${proto}://${url}/main/metricas/pessoal/rescisoes`,
        opt: {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ empresa, mes, ano })
        },
      }}
    >
    {data => data && (
      <Tabela>
        <TabelaLinha header>
          <Celula>Dia</Celula>
          <Celula>Nome</Celula>
          <Celula>Tipo</Celula>
        </TabelaLinha>
        {data.map(e => {
          return (
            <TabelaLinha>
              <Celula>{e.dia}</Celula>
              <Celula>{e.nome}</Celula>
              <Celula>{e.tipo}</Celula>
            </TabelaLinha>
          )
        })}
      </Tabela>
    )}
    </MoreInfo>
  )
}
